<template>
  <div class="failure-statistics">
    <div class="failure-statistics-title">
      <h2>{{ $t('home_fault_statistics') }}</h2>
      <div class="failure-statistics-title-right">
        <!-- 客户列表,只有超级管理员及infypower的客户用户才显示 -->
        <a-select
          :getPopupContainer="triggerNode => triggerNode.parentNode"
          v-model="customerId"
          show-search
          :placeholder="$t('customer_form_select_placehoder')"
          :allowClear="customerId !== 0"
          @change="deviceCustomerChange"
          v-if="isSuperAdmin || isInfypowerCustomer"
          class="mr12"
          :filter-option="
            (input, option) => {
              return (
                option.componentOptions.children[0].text
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              );
            }
          "
        >
          <a-select-option :value="0">
            {{ $t('customer_form_all_customer') }}
          </a-select-option>
          <a-select-option
            v-for="customer in customerList"
            :key="customer.customerId"
            :value="customer.customerId"
          >
            {{ customer.name }}
          </a-select-option>
        </a-select>
        <!-- 日期Filter -->
        <DateFilter @change="filterChange" />
      </div>
    </div>
    <div class="failure-statistics-content">
      <Loading :show="faultStatisticsLoading" type="icon" v-if="faultStatisticsLoading" />
      <ColumnarChart
        :dataSource="chartData"
        legendField="faultName"
        xField="startDate"
        :xLabelFormatter="
          value => {
            return moment(value).format(timeFormat);
          }
        "
        v-if="chartData"
      />
    </div>
  </div>
</template>
<script>
import { splitTimeRangeWithData, sortFaultData } from '@/libs/utils';
import { DeviceFaultStat } from '@/api/home';
import DateFilter from '@/components/DateFilter';
import ColumnarChart from '_c/charts/Columnar';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  components: { DateFilter, ColumnarChart },
  props: {
    // 客户列表
    customerList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      moment,
      chartData: null,
      failureTypeValue: 0,

      // 故障类型
      // 1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)
      failureTypeList: [
        {
          value: 1,
          label: this.$t('com_fault_type_offline'),
        },
        {
          value: 2,
          label: this.$t('com_fault_type_alarm'),
        },
        {
          value: 3,
          label: this.$t('com_fault_type_unavailable'),
        },
      ],
      // 客户Id
      customerId: 0,
      // 故障统计日期
      failureDate: null,
      // 时间间隔
      timeValue: null,
      modeValue: null,
      timeFormat: '',

      // 日期列表
      monthList: null,
      chart: null,

      faultStatisticsLoading: false,
    };
  },
  computed: {
    ...mapState(['isSuperAdmin', 'isInfypowerCustomer']),
  },
  mounted() {
    // 默认当前
    // this.failureDate = moment();

    this.getChartData();
  },
  methods: {
    // 切换客户
    deviceCustomerChange(value) {
      this.customerId = value;

      this.getChartData();
    },

    // 切换故障统计类型
    handleFailureTypeChange(value) {
      this.failureTypeValue = value;
    },

    // 切换故障统计日期
    handleFailureDate(value) {
      this.failureDate = value;
    },

    // 查询故障统计
    handleFailure() {
      this.getChartData();
    },

    // get data
    getChartData() {
      if (!this.failureDate) {
        return;
      }

      // 区间
      let startDate = '';
      let endDate = '';
      if (this.failureDate && this.failureDate.length === 2) {
        startDate = this.failureDate[0].format('YYYY/MM/DD 00:00:00');
        endDate = this.failureDate[1].format('YYYY/MM/DD 23:59:59');
      } else {
        startDate = this.failureDate.format('YYYY/MM/DD 00:00:00');
        endDate = this.failureDate.format('YYYY/MM/DD 23:59:59');
      }

      // console.log('failureDate', this.failureDate);
      // console.log('startDate', startDate);
      // console.log('endDate', endDate);
      this.faultStatisticsLoading = true;
      DeviceFaultStat({
        customerId: this.customerId,
        startTime: new Date(startDate).getTime(),
        endTime: new Date(endDate).getTime(),
      })
        .then(res => {
          // console.log('res', res);
          let _data = res?.data || [];

          _data = splitTimeRangeWithData(
            startDate,
            endDate,
            this.timeValue,
            res.data,
            'startDate',
            'faultDynamicStatus'
          );

          _data.forEach(record => {
            // 处理数据，添加一个报错名称的字段
            // faultDynamicStatus:"故障类型，1-离线(offline)，2-告警(Alarm)，3-故障(Unavailable)",
            record.faultName = record.faultDynamicStatus;
          });

          // 根据故障类型排序
          _data = sortFaultData(_data, 'faultDynamicStatus');
          this.chartData = _data;
        })
        .finally(() => {
          this.faultStatisticsLoading = false;
        });
    },

    // filter
    filterChange(data) {
      this.failureDate = data.date;
      this.timeValue = data.time;
      this.modeValue = data.modeValue;
      this.timeFormat = data.timeFormat;

      this.getChartData();
    },
  },
};
</script>
<style lang="less" scoped>
.failure-statistics {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  // 标题
  .failure-statistics-title {
    color: #18181a;
    display: flex;
    justify-content: space-between;
    white-space: nowrap;
    height: 30px;
    align-items: center;

    h2 {
      margin: 0;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
    }
    .failure-statistics-title-right {
      display: flex;
      flex: 1;
      justify-content: flex-end;
    }

    .mr12 {
      margin-right: 12px;
    }
  }
  // content
  .failure-statistics-content {
    height: 100%;
    margin-top: 16px;
    width: 100%;
    display: flex;
    flex: 1;

    .failure-statistics-chart {
      width: 100%;
    }
  }
}
</style>
